import { render, staticRenderFns } from "./InwardHandlingItems.vue?vue&type=template&id=48f8db88&"
import script from "./InwardHandlingItems.vue?vue&type=script&lang=js&"
export * from "./InwardHandlingItems.vue?vue&type=script&lang=js&"
import style0 from "./InwardHandlingItems.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports